export default "__VITE_ASSET__DdM9JVRR__"